// extracted by mini-css-extract-plugin
module.exports =  {"mobile-banner":"_2787e5dfdf--mobile-banner--DXBAS"};